import React from "react";

/**
 * Shared type/heading primitives for the landing page sections below the hero.
 * Mirrors the hero's language: mono eyebrow pill, tight display heading with a
 * Newsreader italic accent line, muted body copy.
 */

export const ACCENT = "#4d7c0f";

export const monoFont = { fontFamily: "var(--font-geist-mono)" };

export const serifEm = {
  color: ACCENT,
  fontStyle: "italic",
  fontFamily: "var(--font-newsreader)",
  fontWeight: 400,
};

export function Eyebrow({ children }) {
  return (
    <div
      className="inline-flex h-7 items-center gap-2 rounded-full border border-neutral-200 bg-white px-3 text-[12px] text-neutral-500"
      style={monoFont}
    >
      <span
        className="h-1.5 w-1.5 rounded-full"
        style={{ background: ACCENT }}
      />
      {children}
    </div>
  );
}

export function SectionTitle({
  eyebrow,
  title,
  em,
  body,
  center = false,
  size = "lg",
  className = "",
}) {
  const heading =
    size === "lg"
      ? "text-[clamp(36px,4.6vw,64px)]"
      : "text-[clamp(32px,3.8vw,52px)]";

  return (
    <div
      className={`max-w-3xl ${center ? "mx-auto text-center" : ""} ${className}`}
    >
      <Eyebrow>{eyebrow}</Eyebrow>
      <h2
        className={`mt-6 ${heading} font-medium leading-[1] tracking-[-0.03em] text-neutral-900`}
      >
        {title}
        <br />
        <span style={serifEm}>{em}</span>
      </h2>
      {body && (
        <p
          className={`mt-6 max-w-xl text-[17px] leading-[1.55] text-neutral-500 ${
            center ? "mx-auto" : ""
          }`}
        >
          {body}
        </p>
      )}
    </div>
  );
}
